import "./Home.module.css";
import Cabecalho from "@/reusable_sections/Header";
import CienciaECuidadoParaSeusCabelos from "./sections/CienciaECuidadoParaSeusCabelos";
import OCaminhoDoDiagnostico from "./sections/OCaminhoDoDiagnostico";
import SolucoesParaSuaSaudeCapilar from "./sections/SolucoesParaSuaSaudeCapilar";
import OurClinicalEssence from "./sections/OurClinicalEssence";
import VozesDeTransformacao from "./sections/VozesDeTransformacao";
import StartRecoveryJourney from "./sections/StartRecoveryJourney";
import Rodape from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Cabecalho />
      <CienciaECuidadoParaSeusCabelos />
      <OCaminhoDoDiagnostico />
      <SolucoesParaSuaSaudeCapilar />
      <OurClinicalEssence />
      <VozesDeTransformacao />
      <StartRecoveryJourney />
      <Rodape />
    </div>;
}